import closeIcon from "../../assests/images/dashboard/Vector 3.png";
import defaultImg from "../../assests/images/dashboard/default-thumbnail (1).jpg";
import editIcon from "../../assests/images/dashboard/pencil.png";
import { useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { GRAPHQL_ENDPOINT, S3_BASE_URL } from "src/constants/endpoints";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { BtnLoader } from "src/Loader";
import ComboItemsModal from "../ComboItemsModal/ComboItemsModal";
import { successToast } from "src/utils/toasts";
import { ADD_COMBO, UPLOAD_COMBO_IMAGE } from "src/constants/mutations";
import { useAuth } from "src/contexts/auth-provider";
import { mimeTypeToExtension } from "../RestaurantSetting/RestaurantSettingComponent";
import axios from "axios";
import Dropzone from "react-dropzone";
import { convertDollarToCents } from "src/helpers";
import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";
import MenuItemLocaleFields from "src/components/common/MenuItemLocaleFields";
import { useStorePosLocales } from "src/hooks/useStorePosLocales";
import {
  buildLocaleTranslationMap,
  buildTranslationsPayload,
  LocaleTranslationMap,
  syncLegacyFieldsFromLocaleTranslations,
} from "src/utils/localeTranslations";

export const ManageComboModal = ({
  setShowCreateModal,
  title,
  editComboModal,
  getCombos,
}: any) => {
  const { user, hasRestaurant } = useAuth();
  const { axBe } = useAxiosInterceptor();
  const { enabledLocaleOptions, enabledLocales, defaultLocale } = useStorePosLocales();
  const [uploadImageLoader, setUploadImageLoader] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [uploadImage, setUploadImage] = useState<any>(null);
  const [loading, setloading] = useState(false);

  const initialLocaleTranslations = useMemo(
    () =>
      buildLocaleTranslationMap(editComboModal?.translations, enabledLocales, {
        englishName: editComboModal?.englishName,
        nonEnglishName: editComboModal?.nonEnglishName,
        englishDescription: editComboModal?.englishDescription,
        nonEnglishDescription: editComboModal?.nonEnglishDescription,
      }),
    [editComboModal, enabledLocales]
  );
  const [localeTranslations, setLocaleTranslations] = useState<LocaleTranslationMap>(initialLocaleTranslations);

  useEffect(() => {
    setLocaleTranslations(initialLocaleTranslations);
  }, [initialLocaleTranslations]);

  const formik = useFormik({
    initialValues: {
      priceCents: "",
      taxRate: "",
      itemCorrelationIds: [] as any[],
    },
    validationSchema: Yup.object({
      priceCents: Yup.string().required("Price is Required"),
      taxRate: Yup.string().required("Tax rate is Required"),
    }),
    onSubmit: () => {},
  });
  const { setValues } = formik;

  const createCombo = async () => {
    setloading(true);
    try {
      const legacy = syncLegacyFieldsFromLocaleTranslations(localeTranslations);
      const translations = buildTranslationsPayload(localeTranslations, enabledLocales);
      const variables = {
        createCombosInput: {
          storeUserCorrelationId: user?.storeUser?.correlationId,
          storeCorrelationId: hasRestaurant.correlationId,
          createComboInputs: [{
            storeCorrelationId: hasRestaurant.correlationId,
            englishName: legacy.englishName,
            nonEnglishName: legacy.nonEnglishName || undefined,
            englishDescription: legacy.englishDescription || undefined,
            nonEnglishDescription: legacy.nonEnglishDescription || undefined,
            priceCents: convertDollarToCents(formik.values.priceCents),
            taxRate: formik.values.taxRate,
            itemCorrelationIds: formik.values.itemCorrelationIds?.map((item: any) => item.correlationId || item) || undefined,
            translations,
          }],
        },
      };
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: ADD_COMBO,
        variables: variables,
      });
      if (data?.errors?.length) {
        throw data?.errors;
      }

      const newComboCorrelationId = data?.data?.createCombos[0]?.correlationId;

      if (
        (newComboCorrelationId && uploadImage?.file) ||
        (editComboModal?.correlationId && uploadImage?.file)
      ) {
        await uploadComboImage(newComboCorrelationId || editComboModal?.correlationId || "");
      } else if (newComboCorrelationId && !uploadImage?.file) {
        getCombos();
        setloading(false);
      }
      getCombos();
      successToast("Combo Created!");
      setShowCreateModal();
    } catch (error) {
      console.error("Error creating user:", error);
      setloading(false);
    }
  };

  const uploadComboImage = async (comboCorrelationId: string) => {
    const legacy = syncLegacyFieldsFromLocaleTranslations(localeTranslations);
    const variables = {
      createComboPreSignedUrlInput: {
        storeUserCorrelationId: user?.storeUser?.correlationId,
        storeCorrelationId: hasRestaurant.correlationId,
        comboName: legacy.englishName,
        fileNameExtension: mimeTypeToExtension[uploadImage?.file?.type],
        comboCorrelationId,
      },
    };
    try {
      const res = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPLOAD_COMBO_IMAGE,
        variables: variables,
      });
      if (!res?.data?.error?.length) {
        const awsUrl =
          res.data?.data?.createUploadPreSignedUrlForCombo?.preSignedUrl;
        await axios.put(awsUrl, uploadImage.file, {
          headers: {
            "Content-Type": uploadImage?.file?.type,
            "x-amz-acl": "public-read",
          },
        });
        getCombos();
        setUploadImageLoader(false);
        setShowCreateModal();
        successToast(!!editComboModal ? "Combo Edited!" : "Combo Added!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploadImageLoader(false);
    }
  };

  const handleFileChange = (file: any) => {
    setUploadImage({
      url: URL.createObjectURL(file),
      file,
    });
  };

  useEffect(() => {
    if (!!editComboModal) {
      setValues({
        priceCents: editComboModal?.priceCents ?? "",
        taxRate: editComboModal?.taxRate ?? "",
        itemCorrelationIds: editComboModal?.itemList ?? [],
      });
      if (editComboModal?.bucketName) {
        setUploadImage({
          url: S3_BASE_URL + editComboModal?.bucketName,
          file: null,
        });
      }
    }
  }, [editComboModal, setValues]);

  const defaultLocaleName = localeTranslations[defaultLocale]?.name?.trim() ?? "";
  const isDisabled =
    !formik.values.priceCents ||
    !formik.values.taxRate ||
    defaultLocaleName.length === 0;

  return (
    <>
      <PortaledModalFrame onClose={setShowCreateModal} panelStyle={{ maxWidth: 790 }}>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <div className="flex shrink-0 items-center justify-between gap-2 border-b border-[#F1F1F2] px-5 py-4 sm:px-8">
            <span id="modal-title" className="text-xl font-semibold text-[#252525]">
              {title}
            </span>
            <button
              type="button"
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100"
              onClick={setShowCreateModal}
              aria-label="Close"
            >
              <img className="h-3 w-3" src={closeIcon} alt="" />
            </button>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-5 py-5 sm:px-8">
            <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-start">
              <Dropzone
                accept={{
                  "image/png": [".png"],
                  "image/jpg": [".jpg"],
                  "image/jpeg": [".jpeg"],
                }}
                onDrop={(acceptedFiles) => handleFileChange(acceptedFiles[0])}
              >
                {({ getRootProps, getInputProps }) => (
                  <div>
                    <div className="w-[67px] h-[67px] rounded-lg border border-[#F1F1F2] flex justify-center items-center relative">
                      <img
                        src={
                          uploadImage?.url
                            ? uploadImage?.url
                            : editComboModal?.bucketKeyName
                            ? editComboModal?.bucketKeyName.includes("blob")
                              ? editComboModal?.bucketKeyName
                              : S3_BASE_URL + editComboModal?.bucketKeyName
                            : defaultImg
                        }
                        alt=""
                        className="w-[55px] h-[55px] object-cover"
                      />
                    </div>
                    <button type="button">
                      <img
                        src={editIcon}
                        alt=""
                        className="w-6 h-6 absolute top-[85px] left-[83px]"
                        {...getRootProps()}
                      />
                      <input {...getInputProps()} />
                    </button>
                  </div>
                )}
              </Dropzone>
            </div>

            <MenuItemLocaleFields
              enabledLocaleOptions={enabledLocaleOptions}
              defaultLocale={defaultLocale}
              localeTranslations={localeTranslations}
              onChange={setLocaleTranslations}
              entityLabel="Combo"
            />

            <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
              <div className="w-full sm:flex-1">
                <span className="text-[#9B9B9B] text-sm">
                  Price
                  <span className="text-[red]">*</span>
                </span>
                <input
                  className="text-xs text-[#9B9B9B] h-[40px] w-full border rounded-lg border-[#F1F1F2] mt-1 px-2"
                  type="text"
                  name="priceCents"
                  id="priceCents"
                  value={formik.values.priceCents}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="w-full sm:flex-1">
                <span className="text-[#9B9B9B] text-sm">
                  taxRate
                  <span className="text-[red]">*</span>
                </span>
                <input
                  className="text-xs text-[#9B9B9B] h-[40px] w-full border rounded-lg border-[#F1F1F2] mt-1 px-2"
                  type="text"
                  name="taxRate"
                  id="taxRate"
                  value={formik.values.taxRate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="flex shrink-0 justify-end gap-2 border-t border-[#F1F1F2] px-5 py-4 sm:px-8">
            {uploadImageLoader || loading ? (
              <BtnLoader />
            ) : (
              <button
                type="button"
                className={`flex h-9 items-center justify-center gap-2 rounded-md bg-orange px-8 text-xs text-white hover:bg-orange/90 ${
                  isDisabled ? "opacity-20" : ""
                }`}
                onClick={createCombo}
                disabled={isDisabled}
              >
                Add
              </button>
            )}
          </div>
        </div>
      </PortaledModalFrame>
      {showItemModal ? (
        <ComboItemsModal
          title="Select Menu Item for your combo"
          formik={formik}
          setShowItemModal={() => {
            setShowItemModal(!showItemModal);
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
};
